import { render, staticRenderFns } from "./SectionChecklist.vue?vue&type=template&id=a0bb4d6c&scoped=true"
import script from "./SectionChecklist.vue?vue&type=script&lang=js"
export * from "./SectionChecklist.vue?vue&type=script&lang=js"
import style0 from "./SectionChecklist.vue?vue&type=style&index=0&id=a0bb4d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bb4d6c",
  null
  
)

export default component.exports